import useDeleteClientIdentityApi from '@/hooks/mutate/useDeleteClientIdentityApi'
import { TrashIcon } from 'lucide-react'
import { useState } from 'react'

import { ClientIdentityDto } from '@/gen/publicApi'

import { Button } from '@/components/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/dialog'
import IconButton from '@/components/iconButton'

interface Props {
    clientCode: string
    apiKey: ClientIdentityDto
}

export default function DeleteApiKey({ clientCode, apiKey }: Props) {
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false)
    const { onDelete } = useDeleteClientIdentityApi(clientCode, apiKey.id)

    return (
        <Dialog open={confirmationModalOpen} onOpenChange={setConfirmationModalOpen}>
            <DialogTrigger asChild>
                <IconButton
                    icon={TrashIcon}
                    tooltip="Delete API Key"
                    className="text-destructive hover:text-destructive"
                />
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Are you sure?</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete the API key <code>{apiKey.name}</code>? This action cannot be
                        undone.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="outline" onClick={() => setConfirmationModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={onDelete}>
                        Delete
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
